import { useAppStore } from '../stores/appStore'

const TopNavbar = ({ title }) => {
  const { toggleSidebar } = useAppStore()

  return (
    <div className="top-navbar">
      <button className="menu-toggle" onClick={toggleSidebar}>
        <i>☰</i> 菜单
      </button>
      <h3 className="page-title">{title}</h3>
    </div>
  )
}

export default TopNavbar
